import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import pflLogoNoMargin from "../assets/tutorial/PfL-logo-no-margin-2025.svg";
import justMountains from "../assets/images/just mountains.svg";
import familyImage from "../assets/images/family.jpg";
import workplaceImage from "../assets/images/workplace.jpg";
import CTACard from "../componentLibrary/CTACard";
import InteractiveFeatureGrid from "../componentLibrary/InteractiveFeatureGrid";
import Header from "../components/Header";
import TopicsModal from "../components/TopicsModal";
import Modal from "../componentLibrary/Modal";
import ChallengeTopicsGrid from "../components/ChallengeTopicsGrid";
import PflStorySection from "../components/PflStorySection";
import HowItWorksSection from "../components/HowItWorksSection";

const LandingPage = () => {
  const navigate = useNavigate();
  const [showTopicsModal, setShowTopicsModal] = useState(false);
  const [showBetaTesterModal, setShowBetaTesterModal] = useState(false);

  return (
    <div className="min-h-screen">
      {/* Header */}
      <Header transparent={false} />

      {/* Unified Hero Section */}
      <div className="relative overflow-visible bg-gradient-to-b from-white via-electrum-100 via-electrum-150 to-white">
        {/* Hero Content */}
        <div className="relative z-10 text-center px-4 max-w-4xl mx-auto pt-20 lg:pt-8">
          <h1
            className="text-3xl md:text-4xl font-bold text-gray-900 mb-6"
            style={{ lineHeight: "1.5" }}
          >
            Life Is Challenging.
            <br />
            Enter Psych for Life<sup>®</sup>.
          </h1>

          {/* Main icon - PfL logo no margin 2025 */}
          <div className="flex justify-center mb-4 relative z-20">
            <img
              src={pflLogoNoMargin}
              alt="Psych For Life icon"
              className="w-[140px] h-[140px] md:w-[180px] md:h-[180px] relative z-20"
            />
          </div>

          <p className="text-lg md:text-xl text-gray-800 max-w-3xl mx-auto mb-6 font-bold">
            Psych for Life<sup>®</sup> Equips People to Navigate Obstacles and
            Take Advantage of Opportunities at Home, at Work, and in Life.
          </p>
        </div>

        {/* Mountains Image - Full Width Edge-to-Edge */}
        <div className="relative z-10 mb-0">
          <img
            src={justMountains}
            alt="Mountain landscape"
            className="w-full h-auto"
          />
        </div>

        {/* Second Paragraph */}
        <div className="relative z-10 text-center px-4 max-w-4xl mx-auto py-4 mb-6">
          <p className="text-lg md:text-xl text-gray-800 max-w-3xl mx-auto font-bold">
            Psych for Life<sup>®</sup> provides evidence-based knowledge and
            skills to enhance well-being, relationships, and career.
          </p>
        </div>

        {/* Challenge Areas Icons with Beach Background */}
        <ChallengeTopicsGrid onMoreClick={() => setShowTopicsModal(true)} />
      </div>

      {/* Early CTA Sections */}
      <div className="pt-24 pb-20">
        <div className="max-w-6xl mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 justify-items-center gap-8 lg:gap-12">
            <CTACard
              title="Start Building Your Personal Toolbox of Life-Skills"
              buttonText="Become A Beta Tester"
              onButtonClick={() => setShowBetaTesterModal(true)}
              width="lg"
              imageSrc={familyImage}
              imageAlt="Family using Psych For Life"
            />
            <CTACard
              title={
                <>
                  Learn How Psych for Life<sup>®</sup> Can Support Your
                  Organization
                </>
              }
              buttonText="Learn More"
              onButtonClick={() => {
                navigate("/business");
              }}
              width="lg"
              imageSrc={workplaceImage}
              imageAlt="Workplace collaboration"
            />
          </div>
        </div>
      </div>

      {/* What Does Psych For Life<sup>®</sup> Do For You? Section */}
      <div className="py-20 bg-gradient-to-b from-white via-electrum-50 to-electrum-100">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-5xl font-bold text-electrum text-center mb-16">
            What Psych for Life<sup>®</sup> Does For You
          </h2>

          {/* Interactive Feature Grid */}
          <InteractiveFeatureGrid />
        </div>
      </div>

      {/* How It Works Section */}
      <HowItWorksSection />

      {/* The Story Behind Psych For Life® Section */}
      <PflStorySection />

      {/* Final CTA Section */}
      <div className="py-20">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h2 className="text-5xl font-bold text-electrum mb-8">
            Curious About Your Next Steps?
          </h2>
          <p className="text-2xl text-gray-800 mb-12">
            Whether you&apos;re building a better life or supporting a thriving
            workforce—
            <br />
            Psych for Life<sup>®</sup> is here for you.
          </p>

          <div className="grid grid-cols-1 lg:grid-cols-2 justify-items-center gap-8 lg:gap-12 mt-20">
            <CTACard
              title="Start Building Your Personal Toolbox of Life-Skills"
              buttonText="Become A Beta Tester"
              onButtonClick={() => setShowBetaTesterModal(true)}
              width="lg"
              imageSrc={familyImage}
              imageAlt="Family using Psych For Life"
            />
            <CTACard
              title={
                <>
                  Learn How Psych for Life<sup>®</sup> Can Support Your
                  Organization
                </>
              }
              buttonText="Learn More"
              onButtonClick={() => {
                navigate("/business");
              }}
              width="lg"
              imageSrc={workplaceImage}
              imageAlt="Workplace collaboration"
            />
          </div>
        </div>
      </div>

      {/* Topics Modal */}
      <TopicsModal
        isOpen={showTopicsModal}
        onClose={() => setShowTopicsModal(false)}
      />

      {/* Beta Tester Modal */}
      <Modal
        isOpen={showBetaTesterModal}
        onCloseModal={() => setShowBetaTesterModal(false)}
        title="Become A Beta Tester"
        size="lg"
        height="80vh"
      >
        <div className="w-full h-full">
          <iframe
            src="https://mc5jf8-qft7x07vcws79ngwdhmp1.pub.sfmc-content.com/lxelkbk14so"
            className="w-full h-full border-0"
            title="Beta Tester Form"
            allow="clipboard-write"
          />
        </div>
      </Modal>
    </div>
  );
};

export default LandingPage;
